import DataListBulkActionsContext from "@magicware/data-lists/DataListBulkActionsContext";
import { MenuAction } from "@magicware/data-lists/DataListContextMenu";
import { useTranslation } from "react-i18next";
import { useNewItemMenuAction } from "../../navigation/hooks";
import { useLibraryId } from "../../navigation/libraries";

export default function LibraryVersionListMenuContext(props: { children?: React.ReactNode }) {
    const { t } = useTranslation();
    const actions: MenuAction[] = [];
    const libraryId = useLibraryId();
    const addAction = useNewItemMenuAction(t("add-libraryVersion"), (n) =>
        n.libraries.detail.versions.new.url(libraryId),
    );
    return (
        <DataListBulkActionsContext defaultAction={addAction} actions={actions}>
            {props.children}
        </DataListBulkActionsContext>
    );
}
